import ConfirmationPopup from '../ConfirmationPopup/ConfirmationPopup';
import styles from './CtrPopup.module.css';

interface Props {
    onClose: () => void,
    onConfirm: () => void,
    open: boolean
}

export default function CtrPopup({ onClose, onConfirm, open }: Props) {

    return (
        <ConfirmationPopup
            className={styles.ctrPopup}
            onConfirm={onConfirm}
            onClose={onClose}
            open={open}>
            <h3>WARNING: You <b>MUST</b> file a CTR on this transaction.</h3>
            <p>Do you agree to file a CTR on this transaction?</p>
        </ConfirmationPopup>
    );
}